// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import LogOut from "@insite/mobius/Icons/LogOut";
import { myAccountNavigationListStyles } from "@steiner/App/Widgets/MyAccount/MyAccountNavigationList";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

myAccountNavigationListStyles.sectionLabel = {
    css: css`
        background-color: ${color("primary")};
        padding: 12px;
    `,
};

myAccountNavigationListStyles.wrapper = {
    css: css`
        padding: 0;
        padding-bottom: 12px;
        border: 2px solid ${color("primary")};

        .title {
            background-color: ${color("primary")};
            padding: 12px;
            color: ${color("common.white")};
        }
    `,
};

myAccountNavigationListStyles.mobileWrapper = {
    css: css`
       margin-bottom: 20px;
    `,
};

myAccountNavigationListStyles.mobileLinkWrapper = {
    css: css`
       margin-left: -12px;
    `,
};

myAccountNavigationListStyles.link = {
    typographyProps: {
        size: 14,
        weight: fontConfig.weight.bold,
        css: css`
            letter-spacing: 0;
            line-height: 19px;
        `,
    },
    css: css`
        padding: 0 12px;
    `,
};

myAccountNavigationListStyles.separator = {
    css: css`
        padding-bottom: 15px;
        margin-bottom: 15px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

myAccountNavigationListStyles.mobileNavWrapper = {
    css: css`
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 16px;
    `,
};

myAccountNavigationListStyles.select = {
    cssOverrides: {
        formInputWrapper: css`
            width: 320px;

            ${xScreen("lte", "sm")} {
                width: 220px;
            }

            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
    },
};
